module.exports = __webpack_public_path__ + "static/media/sn1p3r90.9f91f883.png";